import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/embr/assets/images/button2.png'


const _hoisted_1 = { class: "flex items-center justify-between my-2 p-2 space-x-2 relative" }

import { ref, watchEffect, computed } from 'vue';
import TokenInput from '@/components/inputs/TokenInput/TokenInput.vue';
import TradePairToggle from './TradePairToggle.vue';
import { bnum } from '@/lib/utils';
import useNumbers from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import { UseTrading } from '@/composables/trade/useTrading';
import { func } from 'prop-types';
import { val } from 'dom7';

/**
 * TYPES
 */
type Props = {
  tokenInAmount: string;
  tokenInAddress: string;
  tokenOutAmount: string;
  tokenOutAddress: string;
  exactIn: boolean;
  priceImpact?: number;
  effectivePriceMessage?: UseTrading['effectivePriceMessage'];
  tradeLoading?: boolean;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    tokenInAmount: { type: String, required: true },
    tokenInAddress: { type: String, required: true },
    tokenOutAmount: { type: String, required: true },
    tokenOutAddress: { type: String, required: true },
    exactIn: { type: Boolean, required: true },
    priceImpact: { type: Number, required: false },
    effectivePriceMessage: { type: null, required: false },
    tradeLoading: { type: Boolean, required: false }
  } as unknown as undefined,
  emits: ["update:tokenInAmount", "update:tokenInAddress", "update:tokenOutAmount", "update:tokenOutAddress", "update:exactIn", "amountChange"] as unknown as undefined,
  setup(__props: {
  tokenInAmount: string;
  tokenInAddress: string;
  tokenOutAmount: string;
  tokenOutAddress: string;
  exactIn: boolean;
  priceImpact?: number;
  effectivePriceMessage?: UseTrading['effectivePriceMessage'];
  tradeLoading?: boolean;
}, { emit }: { emit: ({
  (e: 'update:tokenInAmount', value: string): void;
  (e: 'update:tokenInAddress', value: string): void;
  (e: 'update:tokenOutAmount', value: string): void;
  (e: 'update:tokenOutAddress', value: string): void;
  (e: 'update:exactIn', value: boolean): void;
  (e: 'amountChange'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { balanceFor } = useTokens();



/**
 * STATE
 */
const _tokenInAmount = ref<string>('');
const _tokenInAddress = ref<string>('');
const _tokenOutAmount = ref<string>('');
const _tokenOutAddress = ref<string>('');
const percent = ref(0);

/**
 * METHODS
 */
function handleInAmountChange(value: string): void {
  emit('update:exactIn', true);
  emit('update:tokenInAmount', value);
  emit('amountChange');
}

function handleOutAmountChange(value: string): void {
  emit('update:exactIn', false);
  emit('update:tokenOutAmount', value);
  emit('amountChange');
}

function handlePercentChange(value: number): void {
  const wantBalance = parseFloat(balanceFor(_tokenInAddress.value)) * value;

  emit('update:exactIn', true);
  emit('update:tokenInAmount', value !== 1 ? wantBalance.toFixed(4).toString() : balanceFor(_tokenInAddress.value));
  emit('amountChange');
}

function handleSwitchAsset(): void {
  const tmpAddress = _tokenInAddress.value;
  const tmpAmount = _tokenInAmount.value;
  _tokenInAddress.value = _tokenOutAddress.value;
  _tokenInAmount.value = _tokenOutAmount.value;
  _tokenOutAddress.value = tmpAddress;
  _tokenOutAmount.value = tmpAmount;

  handleInAmountChange(_tokenInAmount.value);
  handleInAmountChange(_tokenOutAmount.value);
  emit('update:tokenInAddress', _tokenInAddress.value);
  emit('update:tokenOutAddress', _tokenOutAddress.value);
}

/**
 * CALLBACKS
 */
watchEffect(() => {
  console.log('props.tokenOutAddress', props.tokenOutAddress);
  _tokenInAmount.value = props.tokenInAmount;
  _tokenInAddress.value = props.tokenInAddress;
  _tokenOutAmount.value = props.tokenOutAmount;
  _tokenOutAddress.value = props.tokenOutAddress;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TokenInput, {
      amount: _tokenInAmount.value,
      "onUpdate:amount": [
        _cache[0] || (_cache[0] = ($event: any) => (_tokenInAmount.value = $event)),
        handleInAmountChange
      ],
      address: _tokenInAddress.value,
      "onUpdate:address": [
        _cache[1] || (_cache[1] = ($event: any) => (_tokenInAddress.value = $event)),
        _cache[2] || (_cache[2] = ($event: any) => (emit('update:tokenInAddress', $event)))
      ],
      name: "tokenIn",
      actionType: "Sell",
      onPercent: percent.value,
      className: "swap-input",
      excludedTokens: [_tokenOutAddress.value],
      disabled: __props.tradeLoading
    }, null, 8, ["amount", "address", "onPercent", "excludedTokens", "disabled"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "bg-white w-24 h-6 bg-opacity-10 rounded text-center cursor-pointer",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handlePercentChange(0.25)))
      }, " 25% "),
      _createElementVNode("div", {
        class: "bg-white w-24 h-6 bg-opacity-10 rounded text-center cursor-pointer",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handlePercentChange(0.5)))
      }, " 50% "),
      _createElementVNode("div", {
        class: "bg-white w-24 h-6 bg-opacity-10 rounded text-center cursor-pointer",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handlePercentChange(0.75)))
      }, " 75% "),
      _createElementVNode("div", {
        class: "bg-white w-24 h-6 bg-opacity-10 rounded text-center cursor-pointer",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (handlePercentChange(1)))
      }, " 100% ")
    ]),
    _createElementVNode("div", { class: "flex items-center justify-center my-2" }, [
      _createElementVNode("img", {
        src: _imports_0,
        width: "40",
        onClick: handleSwitchAsset,
        style: {"z-index":"1","cursor":"pointer"}
      })
    ]),
    _createVNode(TokenInput, {
      amount: _tokenOutAmount.value,
      "onUpdate:amount": [
        _cache[7] || (_cache[7] = ($event: any) => (_tokenOutAmount.value = $event)),
        handleOutAmountChange
      ],
      address: _tokenOutAddress.value,
      "onUpdate:address": [
        _cache[8] || (_cache[8] = ($event: any) => (_tokenOutAddress.value = $event)),
        _cache[9] || (_cache[9] = ($event: any) => (emit('update:tokenOutAddress', $event)))
      ],
      name: "tokenOut",
      actionType: "Buy",
      priceImpact: __props.priceImpact,
      noRules: "",
      className: "swap-input",
      noMax: "",
      disabled: __props.tradeLoading,
      excludedTokens: [_tokenInAddress.value]
    }, null, 8, ["amount", "address", "priceImpact", "disabled", "excludedTokens"])
  ]))
}
}

})